import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { FormBuilder } from 'shared-components/forms/form';
import { DateInput } from '../elements-inputs/date-input';
import { LocationWrapper } from '../partials-search-form/location-wrapper';
import { ActivitySearch } from '../partials-search-form/activity-search';
import { MoreActivitiesBody } from './project-more-activity';
import Moment from 'moment';
import { FormattedMessage, injectIntl } from 'react-intl';

const dateToSchedule = (momentDate) => {
  const y = momentDate.year();
  const m = momentDate.month() + 1;
  const d = momentDate.date();

  return {
    date: {
      y,
      m,
      d
    }
  };
};

class ProjectModalCreate extends React.Component {
  constructor (props) {
    super(props);

    this.saveSettings = this.saveSettings.bind(this);
    this.dateInput = this.dateInput.bind(this);
    this.getValueFromInput = this.getValueFromInput.bind(this);
    this.validateInput = this.validateInput.bind(this);
    this.saveSettingsCallback = this.saveSettingsCallback.bind(this);
    this.handleUpdateError = this.handleUpdateError.bind(this);
    this.renderLocationDropdown = this.renderLocationDropdown.bind(this);
    this.locationClickCallback = this.locationClickCallback.bind(this);
    this.renderActivityDropdown = this.renderActivityDropdown.bind(this);
    this.activityClickCallback = this.activityClickCallback.bind(this);
    this.seeMore = this.seeMore.bind(this);
    this.renderMoreActivitiesBody = this.renderMoreActivitiesBody.bind(this);
    this.analyticsPayload = this.analyticsPayload.bind(this);
    this.boardNameConstraints = this.boardNameConstraints.bind(this);
    this.addToExistingBoard = this.addToExistingBoard.bind(this);

    this.state = {
      board_name: '',
      activity: '',
      location: '',
      errorText: '',
      moreActivities: false,
      useTypes: []
    };
  }

  componentWillMount () {
    const { listing: { city, state }, error } = this.props;
    const activity = PSSessions.Cookies('PSSK');
    const listingLocation = `${city}, ${state}`;

    this.setState({
      activity,
      location: listingLocation,
      errorText: error
    });
  }

  componentDidMount () {
    const { isFirstTime, listing, analyticsOrigin, activity, useType, listingImgID } = this.analyticsPayload();

    analyticsIntegrations.createBoardViewed(isFirstTime, listing, analyticsOrigin, activity, useType, listingImgID);
  }

  getValueFromInput (value, callback) {
    this.setState(value, () => {
      return callback();
    });
  }

  validateInput (errorData, validState) {
    return validState(errorData);
  }

  addToExistingBoard (existingProject) {
    const { listSave, listSaveCallback, listing } = this.props;
    const project = existingProject._id;
    const value = listing._id;

    const payload = {
      batch: [
        {
          action: 'create',
          ns: 'FAV_BOARD',
          project,
          value
        }
      ]
    };

    listSave(payload, listSaveCallback);
  }

  saveSettings (el, callback, refs, formValues) {
    const { board_name, activity, date, location } = formValues;
    const { createSave, listing } = this.props;

    const payload = {
      ns: 'FAV_BOARD',
      value: listing._id,
      project: {
        name: board_name,
        activity,
        location
      }
    };

    if (date) {
      const momentDate = Moment(date, 'MMM DD, YYYY');
      payload.project.schedule = [{ start: dateToSchedule(momentDate) }];
    }

    return createSave(payload, callback);
  }

  handleUpdateError (err) {
    this.setState({
      errorText: err
    });
  }

  saveSettingsCallback (res) {
    const { createSaveCallback, setModalBody } = this.props;
    const { isFirstTime, listing, analyticsOrigin, activity, useType, listingImgID } = this.analyticsPayload();
    if (res.error || res.errors || 400 < res.statusCode) {
      // Something went wrong when creating the project
      return this.handleUpdateError(this.props.intl.formatMessage({ id: 'boards.project_modal_create.something_wrong', defaultMessage: 'Something went wrong. Please try again later.' }));
    }

    const { body: { project } } = res;
    analyticsIntegrations.boardCreated(isFirstTime, listing, analyticsOrigin, activity, useType, listingImgID, project);
    analyticsIntegrations.boardListingsSaved(listing, analyticsOrigin, activity, useType, listingImgID, true, [project._id]);

    return createSaveCallback(res, setModalBody);
  }

  captureDate (date) {
    this.setState({
      date
    });
  }

  closeModal () {
    ReactDOM.unmountComponentAtNode(document.getElementById('modal-container'));
    $('#modal-container').modal('hide');
  }

  cancelBtn () {
    return (
      <div className="col-xs-3 col-xs-offset-5">
        <a onClick={ this.closeModal } className="form cancel-btn link-gray-dark inline-block">
          <FormattedMessage
            id="boards.project_modal_create.cancel"
            defaultMessage="Cancel"
          />
        </a>
      </div>
    );
  }

  dateInput () {
    return (
      <div className={'col-sm-6 col-xs-12 half-padding-left'}>
        <div className="form-group has-feedback">
          <label className={`col-xs-12 control-label text-left vert-align-label`}>
            <FormattedMessage
              id="boards.project_modal_create.activity"
              defaultMessage="Activity Date"
            />
          </label>
          <div className={'col-xs-12'}>
            <DateInput
              id="lst-datepkr"
              ref="dateInput"
              dateFormat="MMM DD, YYYY"
              inputFieldName="date"
              weekStart="0"
              optional
            />
          </div>
        </div>
      </div>
    );
  }

  boardNameConstraints (boardName) {
    const { projects } = this.props;
    const existingProject = _.find(projects, { name: boardName });

    const saveToExistingBoard = () => {
      this.addToExistingBoard(existingProject);
    };

    if (existingProject) {
      const { name } = existingProject;
      analyticsIntegrations.duplicateName(name);

      return (
        <span>
          <FormattedMessage
            id="boards.project_modal_create.have_board"
            defaultMessage="You have a board with this name. Choose a new name or {saveSpace}"
            values={{
              saveSpace: (
                <a onClick={ saveToExistingBoard }>
                  <FormattedMessage
                    id="boards.project_modal_create.save_space"
                    defaultMessage="click to save this space to {name}."
                    values={{
                      name: name
                    }}
                  />
                </a>
              )
            }}
          />
        </span>
      );
    }
  }

  locationClickCallback (location) {
    this.setState({
      location
    });
  }

  activityClickCallback (activity) {
    this.setState({
      activity,
      moreActivities: false
    });
  }

  seeMore (useTypes) {
    this.setState({
      useTypes,
      moreActivities: true
    });
  }

  analyticsPayload () {
    const { listing, projects, analyticsOrigin } = this.props;
    const { uses, images } = listing;
    const [firstUse] = uses;
    const [firstImage] = images;
    const activity = PSSessions.Cookies('PSSK');

    const isFirstTime = 0 === projects.length || 1 === projects.length && 'UNCATEGORIZED_FAVS' === projects[0].type;

    // listings can have a different shape based on where the come from (search or listings API),
    // if use_type is available use it
    const useType = listing.use_type || firstUse;
    const listingImgID = firstImage.external_id;

    return {
      isFirstTime,
      listing,
      analyticsOrigin,
      activity,
      useType,
      listingImgID
    };
  }

  renderLocationDropdown () {
    const { location } = this.state;

    return (
      <LocationWrapper
        ref="location"
        inputFieldName="location"
        location={ location }
        clickCallback={ this.locationClickCallback }
        origin={"boards-create"}
      />
    );
  }

  renderActivityDropdown () {
    const { activity } = this.state;

    return (
      <ActivitySearch
        ref="activity"
        inputFieldName="activity"
        activity={ activity }
        projects={this.props}
        clickCallback={ this.activityClickCallback }
        origin={"boards-create"}
        hideSeeMoreActivity
      />
    );
  }

  renderMoreActivitiesBody () {
    const { useTypes } = this.state;
    const alphaActivites = _.sortBy(useTypes, 'dropdown');

    return <MoreActivitiesBody useTypes={ alphaActivites } callback={ this.activityClickCallback } />;
  }

  renderModalBody () {
    const { errorText, board_name, moreActivities } = this.state;
    const { profile } = this.props;
    const firstName = profile && profile.first_name
      ? this.props.intl.formatMessage({ id: 'boards.project_modal_create.name', defaultMessage: "{name}'s" }, { name: profile.first_name })
      : this.props.intl.formatMessage({ id: 'boards.project_modal_create.your', defaultMessage: 'Your' });
    const formInputs = [
      {
        label: this.props.intl.formatMessage({ id: 'boards.project_modal_create.board_name_label', defaultMessage: 'Board Name' }),
        placeholder: this.props.intl.formatMessage({ id: 'boards.project_modal_create.board_name_placeholder', defaultMessage: '{name} Board' }, { name: firstName }),
        inputFieldName: 'board_name',
        elementID: 'board_name',
        ref: 'boardName',
        actionFn: this.getValueFromInput,
        actionCb: this.validateInput,
        optional: false,
        defaultVal: board_name,
        customConstraints: this.boardNameConstraints
      },
      {
        custom: this.renderActivityDropdown
      },
      {
        custom: this.dateInput
      },
      {
        custom: this.renderLocationDropdown
      }
    ];

    if (moreActivities) {
      return this.renderMoreActivitiesBody();
    }

    return (
      <div className="project-create-body">
        <h3 className="text-center project-heading">
          <FormattedMessage
            id="boards.project_modal_create.save_your_space"
            defaultMessage="Save your space to a new board"
          />
        </h3>
        <hr className="thin d-xs-none d-sm-block"/>
        <FormBuilder
          ref="createProjectForm"
          formname="create project form"
          formStyle="modal"
          formInputs={formInputs}
          submitAction={this.saveSettings}
          submitCallback={this.saveSettingsCallback}
          buttonText={ this.props.intl.formatMessage({ id: 'boards.project_modal_create.save_button', defaultMessage: 'Save' }) }
          btnColSize="col-xs-4"
          buttonClass="btn btn-lg btn-primary form"
          errorText={errorText || ''}
          beforeCTA={this.cancelBtn()}
          useBootstrapGrid={false}
        />
      </div>
    );
  }

  render () {
    return (
      <div>
        { this.renderModalBody() }
      </div>
    );
  }
}

ProjectModalCreate.propTypes = {
  listing: PropTypes.object.isRequired,
  setModalBody: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  origin: PropTypes.string,
  error: PropTypes.string,
  createSave: PropTypes.func,
  createSaveCallback: PropTypes.func,
  projects: PropTypes.array,
  analyticsOrigin: PropTypes.string,
  profile: PropTypes.object,
  listSave: PropTypes.func,
  listSaveCallback: PropTypes.func
};

exports.ProjectModalCreate = injectIntl(ProjectModalCreate);
